module.exports = __webpack_public_path__ + "img/archery_range_small.8b10d539.png";